<template>
  <BasicLayout v-slot:default="slotProps">
    <div class="page">
      <div class="page__content">
        <CheckoutProcess />
        <dl class="contract-number">
          <dt>Auftragsnummer:</dt>
          <dd>{{ slotProps.number }}</dd>
        </dl>
        <div>
          <h2>
            {{
              slotProps.order.status === 'closed'
                ? 'Fahrzeug geliefert'
                : 'Details zur Lieferung & Zulassung'
            }}
          </h2>
          <p class="sub-title-text">
            {{
              slotProps.order.status === 'closed'
                ? 'Das Fahrzeug wurde geliefert. Gute Fahrt!'
                : 'Unser Partner plant gerade Lieferung und Zulassung für Sie.'
            }}
          </p>
        </div>
        <Contacts />
      </div>
      <SidebarSummary v-if="slotProps.car" :order="slotProps.order" :car="slotProps.car" />
    </div>
  </BasicLayout>
</template>

<script>
import SidebarSummary from '@/components/SidebarSummary';
import BasicLayout from '../components/layout/BasicLayout';
import Contacts from '../components/Contacts';
import Status from '../components/Status';
import CheckoutProcess from '../components/CheckoutProcess';
import CarDetails from '../components/CarDetails';
import BankConditions from '../components/BankConditions';

export default {
  components: {
    BasicLayout,
    Contacts,
    BankConditions,
    Status,
    CheckoutProcess,
    CarDetails,
    SidebarSummary,
  },
  computed: {
    isMobile() {
      return window.innerWidth <= 520;
    },
    isDesktop() {
      return window.innerWidth > 990;
    },
  },
};
</script>

<style lang="scss" scoped>
.delivery-details {
  h2 {
    padding: 0.9375rem 0.625rem 0.3125rem;
    font-size: 0.875rem;
  }
  h3 {
    padding: 0 0.625rem;
    margin-bottom: 0.3125rem;
    font-size: 0.75rem;
  }
  &__text {
    padding: 0 0.625rem 1.25rem;
    font-size: 0.75rem;
  }
  &__info {
    margin: 0 0.625rem 20px;
    padding: 1.25rem 0.9375rem 1.25rem 3.125rem;
    border: 0.0625rem solid #e5e5e5;
    font-size: 0.8125rem;
    line-height: 1rem;
  }
  &__date-content {
    position: relative;
    margin-bottom: 1.25rem;
    &:before {
      @include icon('\f073', $darkgray, 23px);
      top: 0.4375rem;
      left: -2.1875rem;
      width: 1.1875rem;
      height: 1.4375rem;
      font-weight: 400;
      opacity: 0.3;
    }
  }
  &__address {
    position: relative;
    &:before {
      @include icon('\f2bb', $darkgray, 23px);
      top: 0.4375rem;
      left: -2.3125rem;
      width: 1.1875rem;
      height: 1.4375rem;
      font-weight: 400;
      opacity: 0.3;
    }
    b {
      display: block;
    }
  }
  @include breakpoint(tablet) {
    max-width: 44.375rem;
    margin: 0 auto;
    padding: 0 1.875rem;
    background-color: #e5e5e5;
    &__content {
      background-color: $white;
    }
    h2 {
      padding: 0.9375rem 1.875rem 0.3125rem;
    }
    h3 {
      padding: 0 1.875rem;
    }
    &__info {
      display: flex;
      margin: 0 1.875rem 1.25rem 0;
    }
    &__text {
      padding: 0 1.875rem 1.25rem;
    }
    &__date-content {
      margin-bottom: 0;
      padding-right: 100px;
    }
  }
  @include breakpoint(desktop) {
    padding: 0;
    h2 {
      font-size: 30px;
      padding-top:3rem;
    }
    h3 {
      font-size: 0.875rem;
    }
    p {
      font-size: 1rem;
      line-height: 24px;
    }
    &__info {
      display: flex;
      font-size: 0.875rem;
    }
    &__date-content {
      margin-bottom: 0;
      b{
        width: 110px;
        display: inline-block;
      }
    }
  }
}
</style>
